// Un fichier par zone de l'application ; tout fichier ajoute ici doit l'etre aussi
// dans l'autre langue (test src/i18n/__tests__/i18n.test.js).
import account from './account.json';
import admin from './admin.json';
import agentsVerbalisateurs from './agentsVerbalisateurs.json';
import applicationMobile from './applicationMobile.json';
import attestations from './attestations.json';
import attestationsDigitales from './attestationsDigitales.json';
import auth from './auth.json';
import bilaterales from './bilaterales.json';
import clesApi from './clesApi.json';
import commun from './commun.json';
import comptabilite from './comptabilite.json';
import conversations from './conversations.json';
import courriers from './courriers.json';
import dashboard from './dashboard.json';
import declaration from './declaration.json';
import delais from './delais.json';
import discussions from './discussions.json';
import documents from './documents.json';
import dossierFinance from './dossierFinance.json';
import dossierSinistre from './dossierSinistre.json';
import encaissements from './encaissements.json';
import expertises from './expertises.json';
import experts from './experts.json';
import ged from './ged.json';
import habilitations from './habilitations.json';
import indemnisation from './indemnisation.json';
import journalActivite from './journalActivite.json';
import menu from './menu.json';
import messagerie from './messagerie.json';
import mobile from './mobile.json';
import organismes from './organismes.json';
import paiements from './paiements.json';
import parametres from './parametres.json';
import partenaires from './partenaires.json';
import performance from './performance.json';
import profils from './profils.json';
import pvSinistres from './pvSinistres.json';
import reclamations from './reclamations.json';
import referentiels from './referentiels.json';
import reglementsExperts from './reglementsExperts.json';
import relances from './relances.json';
import reprise from './reprise.json';
import securite from './securite.json';
import security from './security.json';
import sinistres from './sinistres.json';
import statistiques from './statistiques.json';
import utilisateurs from './utilisateurs.json';
import verification from './verification.json';

const ressources = {
  account,
  admin,
  agentsVerbalisateurs,
  applicationMobile,
  attestations,
  attestationsDigitales,
  auth,
  bilaterales,
  clesApi,
  commun,
  comptabilite,
  conversations,
  courriers,
  dashboard,
  declaration,
  delais,
  discussions,
  documents,
  dossierFinance,
  dossierSinistre,
  encaissements,
  expertises,
  experts,
  ged,
  habilitations,
  indemnisation,
  journalActivite,
  menu,
  messagerie,
  mobile,
  organismes,
  paiements,
  parametres,
  partenaires,
  performance,
  profils,
  pvSinistres,
  reclamations,
  referentiels,
  reglementsExperts,
  relances,
  reprise,
  securite,
  security,
  sinistres,
  statistiques,
  utilisateurs,
  verification,
};

export default ressources;
